import css from "styled-jsx/css";

export const componentStyles = css`
    .automations-wrapper{
        max-width: 720px;

        .automation-image {
            height: auto;
            width: 100%;
            margin-bottom: 16px;
        }
    }
`;